import { createRouter, createWebHistory } from 'vue-router'
import { applyRouteSeo, defaultHomeSeo } from '@/utils/seo'
import { isHarmonyOS } from '@/utils/platform.mjs'
import { getActiveLocale } from '@/i18n/useLocale'

import HomePage from '@/views/HomePage.vue'
import InvitePage from '@/views/InvitePage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      seo: defaultHomeSeo
    }
  },
  {
    path: '/help',
    beforeEnter(to) {
      const locale = to.query.lang || getActiveLocale()
      window.location.href = `/happypet/help.html?lang=${encodeURIComponent(locale)}`
    }
  },
  {
    path: '/terms',
    beforeEnter(to) {
      const locale = to.query.lang || getActiveLocale()
      window.location.href = `/happypet/terms.html?lang=${encodeURIComponent(locale)}`
    }
  },
  {
    path: '/privacy',
    beforeEnter(to) {
      const locale = to.query.lang || (isHarmonyOS(window.navigator.userAgent) ? 'zh' : getActiveLocale())
      window.location.replace(`/happypet/privacy.html?lang=${encodeURIComponent(locale)}`)
      return false
    }
  },
  {
    path: '/invite/:code',
    name: 'Invite',
    component: InvitePage,
    meta: {
      seo: {
        title: 'Happy Pets Invite | Start Co-Raising a Virtual Pet',
        description: 'Open your Happy Pets invitation to adopt or co-raise a virtual pet with friends on iPhone and Android.',
        canonical: '/',
        robots: 'noindex,nofollow'
      }
    },
    props: route => ({
      code: route.params.code,
      msg: route.query.msg
    })
  },
  {
    path: '/co-parent/:code',
    name: 'CoParentInvite',
    component: InvitePage,
    meta: {
      seo: {
        title: 'Happy Pets Invite | Start Co-Raising a Virtual Pet',
        description: 'Open your Happy Pets invitation to adopt or co-raise a virtual pet with friends on iPhone and Android.',
        canonical: '/',
        robots: 'noindex,nofollow'
      }
    },
    props: route => ({
      code: route.params.code,
      msg: route.query.msg
    })
  }
]

const router = createRouter({
  history: createWebHistory('/happypet/'), // 👈 设置 base 路径
  routes
})

router.afterEach((to) => {
  applyRouteSeo(to, getActiveLocale())
})

export default router
